import { Component, OnInit } from '@angular/core';
import { EventsKey } from 'ol/events';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { CrossSectionService } from 'src/app/services/cross-section.service';
import { TabsService } from 'src/app/services/tabsService';
import { ToolsControlService } from 'src/app/services/tools-control.service';

@Component({
  selector: 'app-cross-section',
  templateUrl: './cross-section.component.html',
  styleUrls: ['./cross-section.component.scss'],
  standalone: false
})
export class CrossSectionComponent implements OnInit {

  constructor(
    public crossSectionController: CrossSectionService,
    public toolsService: ToolsControlService,
    public menuController: MenuManagementService,
    private globalSelectionService: GlobalSelectionControlService,
    public tabsService: TabsService
  ) { }

  ngOnInit(): void {

    this.crossSectionController.ctx = document.getElementById("crossSectionCanvas") as HTMLCanvasElement;

  }

  cancelWindow(): void {
    this.crossSectionController.cancelWindow();
    }

}
